module.exports = __webpack_public_path__ + "media/images/icon-workbook-large-1dd231f5.png";